import type { SearchState } from '@reducers/search';
import { useViewport } from '@sbt-web/hooks';
import { CategoryID } from '@sbt-web/network/types';
import { Button } from '@sbt-web/ui';
import { useSavedSearches } from '@shared/helpers/SavedSearches';
import React, { type FC } from 'react';
import BellOff from './BellOff';
import type { FiltersConfigState } from '@reducers/filtersConfig';

type Props = {
  search: SearchState;
  filtersConfig: FiltersConfigState;
};

const SavedSearchButton: FC<Props> = (props) => {
  const { isMobile } = useViewport();

  const { search, filtersConfig } = props;
  const savedSearchesProvider = useSavedSearches();

  const handleSave = (e: React.MouseEvent) => {
    e.preventDefault();

    savedSearchesProvider.saveSearch(search, filtersConfig);
  };

  const buttonIsVisible = !(
    search.category.id === CategoryID.Tutte &&
    search.geo.region.id === '0' &&
    // I.E. the search is undefined or an empty string
    (search.query?.length ?? 0) === 0
  );

  return (
    <div id="saved-search-button">
      {buttonIsVisible ? (
        <Button
          design="text"
          size={isMobile ? 'small' : 'medium'}
          onClick={handleSave}
          icon={<BellOff isMobile={isMobile} />}
        >
          Salva ricerca
        </Button>
      ) : null}
    </div>
  );
};

export default SavedSearchButton;
